import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/voiceagent-app/RestroAgent/src/client/components/ui/ClientToaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/var/www/voiceagent-app/RestroAgent/src/client/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/var/www/voiceagent-app/RestroAgent/src/client/contexts/LanguageContext.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/voiceagent-app/RestroAgent/src/styles/tailwind.css");
